import { sourceTooltip } from './drillzCampaignProgress';

export { sourceTooltip };

/** Database / API sources for Sample Tracking dashboard tooltips. */
export const SAMPLE_TRACKING_DATA_SOURCES = {
  holeList: 'drilling_progress.mv_result_progress_status_qaqc_news (/api/result_progress)',
  priority: 'drilling_progress.mv_drilling_progress_metrics.priority (/api/sample_tracking)',
  expectedCompletion: 'drilling_progress.mv_drilling_progress_metrics.expected_completion_date (/api/sample_tracking)',
  workorderCount: 'drilling_progress.mv_result_progress_status_qaqc_news.workorder_numbers',
  workorderList: 'drilling_progress.mv_result_progress_status_qaqc_news.workorder_numbers',
  workorderStatus:
    'qaqc.vw_workorder_qaqc_status.status reconciled over mv_result_progress_status_qaqc_news.workorder_statuses (/api/workorder_qaqc_status)',
  qaqcBadge: 'drilling_progress.mv_result_progress_status_qaqc_news.qaqc_passed_ordered',
  newsRelease: 'drilling_progress.mv_drilling_progress_metrics.news_release_date (/api/sample_tracking)',
  newsReleaseOrdered: 'drilling_progress.mv_result_progress_status_qaqc_news.news_release_date_ordered',
  collarLocation: 'drilling_progress.mv_news_release_collar_locations (/api/collar_locations)',
  finalEta: 'drilling_progress.mv_result_progress_status_qaqc_news.final_eta',
  workorderCpt: 'drilling_progress.mv_drilling_progress_metrics.workorder_cpts',
  workorderType: 'drilling_progress.mv_drilling_progress_metrics.workorder_types (/api/sample_tracking)',
  workorderDepth:
    'drilling_progress.mv_drilling_progress_metrics.sample_depths (fallback: qaqc.vw_workorder_qaqc_status.workorder_depths)',
  workorderSampleCount:
    'drilling_progress.mv_drilling_progress_metrics.workorder_sample_counts (fallback: qaqc.vw_workorder_qaqc_status.sample_count)',
  workorderQaqc: 'qaqc.vw_workorder_qaqc_status.qaqc_passed (/api/workorder_qaqc_status)',
  colmatch: 'clean.vw_results_holes_passed_colmatch_debug (/api/holes_colmatch)',
  colmatchFailedStatus:
    'qaqc.failures unresolved rows on assay workorders (/api/holes_unresolved_failures); PENDING from workorder status; MISSING SAMPLES from INCOMPLETE_ORIG_SAMPLES when all finalized',
  timeline: 'drilling_progress.mv_drilling_progress_metrics.expected_completion_date',
  sampleLocation: 'sample_progress.sample_location (/api/sample_location)',
  alsSyncLog: 'als_raw.als_sync_log (/api/als_sync_log)',
  summaryHoles: 'drilling_progress.mv_result_progress_status_qaqc_news',
  summaryWorkorders: 'drilling_progress.mv_result_progress_status_qaqc_news.workorder_numbers',
  summaryQaqcPassed: 'drilling_progress.mv_result_progress_status_qaqc_news.qaqc_passed_ordered',
  labApprovalCost:
    'als_approvals.workorder_approvals (approved=true) + mv_drilling_progress_metrics workorder_types (/api/lab_approval_cost_metrics)',
  labApprovalCostFormula:
    'Weighted avg: SUM(unit_cost × sample_num_analysis) / SUM(sample_num_analysis); unit_cost = average_sample_cost or total ÷ sample_num_analysis',
};
